export default __webpack_public_path__ + "static/media/gallery_00.9d328e35.jpg";